import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {MenusPage} from './menus.page';

const routes: Routes = [
  {
    path: '',
    component: MenusPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MenusPageRoutingModule {}
